import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Areas = lazy(() => import('./Areas'));

/**
 * The Areas routes.
 */
const areasRoutes: FuseRouteItemType[] = [
	{
		path: 'areas',
		children: [
			{
				index: true,
				element: <Areas />
			},
			{
				path: ':areaId',
				element: <Areas />
			}
		]
	}
];

export default areasRoutes;
